import React from 'react';
import packageJson from '../../../package.json';

const Footer = ({ darkMode }) => {
  return (
    <footer className={`py-2 mt-5 ${darkMode ? 'bg-dark' : 'bg-light'}`}>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-12'>
            <small>GK Office {packageJson.version}</small>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
